document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector('.header'); // adjust if class is different

  if (!header) return;

  window.addEventListener('scroll', function () {
    if (window.scrollY > 100) {
      header.classList.add('sticky-active');
      header.classList.remove('header--hidden'); // force show
    } else {
      header.classList.remove('sticky-active');
    }
  });
}); 


document.addEventListener('DOMContentLoaded', function () {

    // Only run on Wholesale Order Form page
    if (!window.location.pathname.includes('/apps/shop')) return;

    // Top Navigation Buttons
    const tabContainer = document.querySelector('#wof_tab_container') ;

    if (tabContainer && !document.querySelector('.custom-wholesale-nav')) {

        tabContainer.insertAdjacentHTML('beforebegin', `
            <div class="custom-wholesale-nav" style="margin-bottom:20px; display:flex; gap:10px;">
                <a href="/account" class="button">
                    Back to Dashboard
                </a>

                <a href="/account" class="button button--secondary">
                    Order History
                </a>
            </div>
        `);
    }

    // Bottom Buttons
    const formWrapper = document.querySelector('#wof-main-content-wrapper');

    if (formWrapper && !document.querySelector('.custom-order-actions')) {

        formWrapper.insertAdjacentHTML('afterend', `
            <div class="custom-order-actions">
                <a href="/cart" class="button  button--primary">
                    View Cart
                </a>

                <a href="/checkout" class="button  button--tertiary">
                    Checkout
                </a>
            </div>
        `);
    }

});


// Wholesale Dashboard Page
if (window.location.pathname.includes('/apps/wpdapp/wholesale')) {
    window.addEventListener('load', function () {
        setTimeout(function () {
            const topBar = document.querySelector('#top_bar_main_container');
            if (topBar && !document.querySelector('.custom-wholesale-nav')) {

                topBar.insertAdjacentHTML('beforebegin', `
                    <div class="custom-wholesale-nav" style="display:flex;justify-content:flex-end;gap:10px;margin-bottom:20px;">
                        <a href="/account" class="button">
                            Back to Dashboard
                        </a>

                        <a href="/account" class="button button--secondary">
                            Order History
                        </a>
                    </div>
                `);
            }
        }, 1000);
    });
}